// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const TabsTabTitle = createStyle({
  fontFamily: '$body',
});
